<template lang="pug">
v-footer.white--text(color="primary", :height="!sm ? '84px' : 'auto'")
  v-container.d-flex.flex-column.flex-sm-row.justify-space-around.align-center 
    span.text-center.py-2.text-body-1.d-flex.flex-column.flex-sm-row.justify-center.mb-4.mb-sm-0
      span.mr-1 Todos os direitos reservados.
      span {{ informations.name }} © 2021.
    a(href="https://www.mrxweb.com.br/", target="_blank")
      img.logo-mrx(
        src="/img/mrx.svg",
        alt="MRX Web Sites",
        title="MRX Web Sites"
      )
</template>

<script>
export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style>
.logo-mrx {
  height: 20px;
  filter: brightness(0) invert(1);
}
</style>
